import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { mediaDir } from '../../../../../appolloConfig';
import { Divider } from '../../../../atoms/Dividers/Divider';
import { UserPosition } from '../../../../../types/leaderboard/leaderboard';

export interface TableDataLineLeaderboardProps {
  user: UserPosition;
  isMobile?: boolean;
}

export const TableDataLineLeaderboard = ({
  user,
  isMobile = false
}: TableDataLineLeaderboardProps) => {
  const userAvatar = user?.avatar?.media?.url
    ? mediaDir + user?.avatar?.media?.url
    : null;
  return (
    <>
      <tr>
        <TableDataCase variant={'rank'} data={user?.rank} />
        <TableDataCase
          variant={'avatar'}
          source={userAvatar}
          alt={user?.firstname}
        />
        <TableDataCase variant={'name'} data={`${user?.username}`} />
        {!isMobile && <TableDataCase variant={'data'} data={user?.ville} />}
        <TableDataCase variant={'note'} data={user?.moyennegenerale} />
      </tr>
      <tr>
        <Divider color={'light'} margin={false} />
      </tr>
    </>
  );
};
